<app-popover-layout
  style="
    flex-grow: 1;
    overflow: hidden;
    width: min(540px, calc(100vw - 32px));
    gap: 0;
    padding: 0;
    box-sizing: border-box;
  "
>
  <div class="announcement-content" [class.announcement-content--long]="currentLayout() === 'long'" [class.announcement-content--small]="currentLayout() === 'small'" [class.announcement-content--mobile]="isMobile()" *ngIf="announcement">
    <!-- Header -->
    <div class="announcement-header">
      <div class="header-top">
        <span class="date" *ngIf="announcement.createdAt || announcement.publishDate">
          {{ (announcement.createdAt || announcement.publishDate) | date: 'MMM d' }}
        </span>
        <div class="header-center">
          <a 
            *ngIf="hasChangelogUrl()" 
            [href]="announcement.changelogUrl" 
            (click)="onChangelogClick($event)"
            class="changelog-link"
          >
            <span class="announcement-label">Changelog</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="external-link-icon">
              <g clip-path="url(#clip0_1443_45)">
                <path d="M15 16H5C4.73489 15.9996 4.48075 15.8942 4.29329 15.7067C4.10583 15.5193 4.00036 15.2651 4 15V5C4.00036 4.73489 4.10583 4.48075 4.29329 4.29329C4.48075 4.10583 4.73489 4.00036 5 4H10V5H5V15H15V10H16V15C15.9996 15.2651 15.8942 15.5193 15.7067 15.7067C15.5193 15.8942 15.2651 15.9996 15 16Z" fill="#1B1F22"/>
                <path d="M12 3V4H15.293L11 8.293L11.707 9L16 4.707V8H17V3H12Z" fill="#1B1F22"/>
              </g>
              <defs>
                <clipPath id="clip0_1443_45">
                  <rect width="20" height="20" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </a>
          <span class="announcement-label" *ngIf="!hasChangelogUrl()">{{ 'announcement' | translate }}</span>
        </div>
        <button class="close-button" (click)="onClose()" aria-label="Close" [disabled]="isLoading">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Scrollable Content -->
    <div class="scrollable-content">
      <!-- Feature Image (опционально, если приходит отдельно от HTML контента) -->
      <div class="feature-image" *ngIf="announcement.imageUrl && !announcement.content?.includes('feature-image')">
        <img [src]="announcement.imageUrl" [alt]="announcement.title" class="feature-image-img" />
      </div>

      <!-- Main Content -->
      <div class="content-section">
        <!-- Весь контент приходит с бэкенда в поле content -->
        <div 
          #contentContainer
          class="announcement-html-content" 
          [innerHTML]="sanitizedContent"
        ></div>
      </div>
    </div>

    <!-- Footer with buttons -->
    <div class="announcement-footer">
      <app-x-button
        [style]="'outlined'"
        [size]="'32'"
        (click)="onLater()"
        [disabled]="isLoading"
        class="later-button"
      >
        {{ 'later' | translate }}
      </app-x-button>
      <app-x-button
        *ngIf="!showTryNow()"
        [style]="'filled-black'"
        [size]="'32'"
        (click)="onUnderstand()"
        [disabled]="isLoading"
        class="understand-button"
      >
        {{ 'understand' | translate }}
      </app-x-button>
      <app-x-button
        *ngIf="showTryNow()"
        [style]="'filled-black'"
        [size]="'32'"
        (click)="onTryNow()"
        [disabled]="isLoading"
        class="try-now-button"
      >
        {{ 'try_now' | translate }}
      </app-x-button>
    </div>
  </div>
</app-popover-layout>
